export default "__VITE_ASSET__B5LfRI0M__"